// Formato de moneda en colones costarricenses
export function crc(n) {
  return '₡' + Number(n || 0).toLocaleString('es-CR', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
}

export function crcExacto(n) {
  return '₡' + Number(n || 0).toLocaleString('es-CR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

const TZ_CR = 'America/Costa_Rica';
const SIN_ZONA = /^(\d{4}-\d{2}-\d{2})[ T](\d{2}:\d{2}(?::\d{2})?)/;

/**
 * Instantes para mostrar. Costa Rica es UTC-6 todo el año.
 * Un texto MySQL sin zona ("2026-09-09 22:52:05") ya viene en hora de CR.
 * Un ISO con Z se convierte. Un DATE (YYYY-MM-DD) no se corre de dia.
 */
function aDateCR(d) {
  if (!d && d !== 0) return null;
  if (d instanceof Date) return Number.isNaN(d.getTime()) ? null : d;
  const s = String(d).trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return new Date(`${s}T12:00:00-06:00`);
  const m = SIN_ZONA.exec(s);
  if (m && !/[zZ]|[+-]\d{2}:?\d{2}$/.test(s)) {
    const hora = m[2].length === 5 ? `${m[2]}:00` : m[2];
    return new Date(`${m[1]}T${hora}-06:00`);
  }
  const dt = new Date(d);
  return Number.isNaN(dt.getTime()) ? null : dt;
}

export function fecha(d) {
  const dt = aDateCR(d);
  if (!dt) return '';
  return dt.toLocaleDateString('es-CR', {
    day: '2-digit', month: 'short', year: 'numeric', timeZone: TZ_CR,
  });
}

export function fechaHora(d) {
  const dt = aDateCR(d);
  if (!dt) return '';
  return dt.toLocaleString('es-CR', {
    day: '2-digit', month: 'short', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
    timeZone: TZ_CR,
  });
}

/** Ticket / representacion grafica: "09-09-2026 22:52:05" en Costa Rica. */
export function fechaLegal(d) {
  const dt = aDateCR(d) || new Date();
  const partes = new Intl.DateTimeFormat('en-GB', {
    timeZone: TZ_CR,
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit', second: '2-digit',
    hour12: false,
  }).formatToParts(dt);
  const g = (t) => partes.find((p) => p.type === t)?.value || '';
  return `${g('day')}-${g('month')}-${g('year')} ${g('hour')}:${g('minute')}:${g('second')}`;
}

export function diaSemana(d) {
  const dt = aDateCR(d);
  if (!dt) return '';
  return dt.toLocaleDateString('es-CR', { weekday: 'short', timeZone: TZ_CR });
}

export function hoy() {
  const partes = new Intl.DateTimeFormat('en-CA', {
    timeZone: TZ_CR, year: 'numeric', month: '2-digit', day: '2-digit',
  }).formatToParts(new Date());
  const g = (t) => partes.find((p) => p.type === t)?.value || '';
  return `${g('year')}-${g('month')}-${g('day')}`;
}

export const METODOS_PAGO = [
  { value: 'efectivo', label: 'Efectivo' },
  { value: 'tarjeta', label: 'Tarjeta' },
  { value: 'sinpe', label: 'SINPE Movil' },
  { value: 'transferencia', label: 'Transferencia' },
];

export const TIPOS_COMPROBANTE = [
  { value: 'ticket', label: 'Ticket (interno)' },
  { value: 'tiquete_electronico', label: 'Tiquete electronico' },
  { value: 'factura_electronica', label: 'Factura electronica' },
  { value: 'factura_exportacion', label: 'Factura de exportacion' },
  { value: 'proforma', label: 'Proforma' },
];

export const TIPO_COMPROBANTE_LABEL = Object.fromEntries(
  TIPOS_COMPROBANTE.map((t) => [t.value, t.label])
);

/** Comprobantes que se transmiten a Hacienda. */
export const TIPOS_ELECTRONICOS = [
  'tiquete_electronico',
  'factura_electronica',
  'factura_exportacion',
];

/**
 * El IVA se cobra aparte solo en los comprobantes electronicos. En un
 * tiquete normal o una proforma el impuesto ya viene dentro del precio
 * del producto: no se desglosa y se aclara al pie del comprobante.
 */
export const cobraIvaAparte = (tipo) => TIPOS_ELECTRONICOS.includes(tipo);

export const LEYENDA_IVA_INCLUIDO = 'Todos los productos tienen el impuesto incluido.';

export const TIPOS_ID = [
  { value: '01', label: 'Cedula Fisica' },
  { value: '02', label: 'Cedula Juridica' },
  { value: '03', label: 'DIMEX' },
  { value: '04', label: 'NITE' },
];
